export default "__VITE_ASSET__BMeZR567__"